var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6286 0.174532C11.0831 -0.169064 10.6697 0.0146193 10.2958 0.550542C8.65953 2.89952 6.98368 5.22041 5.32322 7.55211C5.86644 7.89786 6.48004 7.70553 7.06065 7.77036C8.56056 5.67638 10.0605 3.58023 11.5648 1.48841C11.8793 1.05189 12.3301 0.61321 11.6286 0.172371V0.174532Z",
    fill: "#9053F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32543 7.55211C5.03293 7.95189 4.70084 8.33006 4.45672 8.75793C4.11803 9.35004 3.86071 9.47538 3.39666 8.83573C2.79406 8.00375 2.10128 7.2366 1.4415 6.44569C1.1358 6.08048 0.803708 5.89248 0.330862 6.23607C-0.137585 6.57534 -0.0386171 7.01186 0.198905 7.33817C0.973053 8.39705 1.67462 9.51643 2.64231 10.4219C3.48023 11.2042 4.23679 11.1847 5.1055 10.4111C5.94343 9.66338 6.46906 8.6931 7.06287 7.77253C6.48225 7.7077 5.86865 7.90002 5.32543 7.55427V7.55211Z",
    fill: "#9053F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMarkIcon);
export default __webpack_public_path__ + "static/media/tickMarkIcon.9241d0ad53aa925f907bcd487984c702.svg";
export { ForwardRef as ReactComponent };